// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__r3_YR","truncatedText":"styles_truncatedText__eN3Bj","fullText":"styles_fullText__ZvXin","textContainer":"styles_textContainer__ZsZHZ"};